import { Component, Inject, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { DialogBase, RentalInfo} from 't4core';
import { RentalDialog } from '../../../../t4common/';
import { OneWayCountingResultInfo, OneWayCountingResult, PinDialog } from '../../../../../projects/t4core/src/public-api';
import { MatStepper } from '@angular/material/stepper';


@Component({
  selector: 'CountingDialog',
  templateUrl: 'CountingDialog.html',
  styleUrls: ['./CountingDialog.css'],
})
export class CountingDialog extends DialogBase {
  public id: string;

  public step: number = 0;
  @ViewChild("stepper")
  private stepper: MatStepper;

  public input: string;
  public trailers: RegNoStatus[] = [];

  // Results
  public found: OneWayCountingResultInfo[] = [];
  public notFound: OneWayCountingResultInfo[] = [];

  public isValid(): boolean {
    return !this.trailers.some(x => x.isValid === false || x.isLoading);
  }

    constructor(
      public dialogRef: MatDialogRef<CountingDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      super("CountingDialog");

      this.id = data.id;
  }

  public inputChanged() {
    var ret = [];

    for (var line of this.input.split("\n")) {
      if (line.trim() == "") continue;

      var trailer = this.trailers.find(x => x.regNo == line);
      if (!trailer) {
        trailer = {
          regNo: line,
          isValid: undefined,
          isLoading: true
        }

        this.validate(line, trailer);
      }

      ret.push(trailer);
    }

    this.trailers = ret;
    this.input = this.input.replace("\n\n", "\n");
  }

  private async validate(number: string, status: RegNoStatus) {
    var ret = await this.Api.get<boolean>("OneWay/ValidateNumber", { number: number });

    status.isLoading = false;
    status.isValid = ret;
  }

  public static async open(dialog: MatDialog, id: string) {
    return await dialog.open(CountingDialog, {
      minWidth: "600px",
      data: { id: id }
    }).afterClosed().toPromise();
  }

  public back() {
    this.stepper.previous();
    this.step--;
  }

  public async next() {
    if (this.step == 0) {
      var token = this.beginLoad("Turbo.OneWay.CountingDialog.msgValidating", "Validating", null);
      // Validate results
      var ret = await this.Api.get<OneWayCountingResultInfo[]>("OneWay/ValidateCountingResults", { objectIds: this.trailers.map(x => x.regNo).join(",") });

      this.found = ret.filter(x => x.Result == OneWayCountingResult.Found).sort((x, y) => {
        if (+x.RentalObject.Alias < +y.RentalObject.Alias) return -1;
        else return 1;
      });
      this.notFound = ret.filter(x => x.Result == OneWayCountingResult.NotFound).sort((x, y) => {
        if (+x.RentalObject.Alias < +y.RentalObject.Alias) return -1;
        else return 1;
      });

      
      this.endLoad(token);
    } else {
      var token = this.beginLoad("Turbo.OneWay.CountingDialog.msgSaving", "Saving", null);
      await this.Api.post<boolean>("OneWay/SaveCountingResult", null, { id: this.id, objectIds: this.trailers.map(x => x.regNo).join(",") });
      this.endLoad(token);
    }

    this.stepper.next();
    this.step++;
  }
}

export class RegNoStatus {
  public regNo: string;
  public isValid: boolean;
  public isLoading: boolean;
}
